<template>
  <!-- div#body:start -->
  <div id="body"
    :class="[
    {'is-hidden-header' : targetScrollFlg},
    {'is-visible-menu':state.visibleMenu},
    {'is-visible-menu-left':state.visibleMenuLeft}
    ]"
  >
  <BackgroundImage />
  

    <!-- SPメニュー -->
    <SPMenu
      :parentVisibleMenu="state.visibleMenu"
      @closeMenu="state.visibleMenu = false"
    />

    <!-- タグ絞り込み設定 -->
    <transition name="popup">
      <SPBookmarkTagExtract
        :data="data"
        v-if="state.vieibleBookmarkTagExtract"
        @closeBookmarkTagExtract="state.vieibleBookmarkTagExtract = false"
      />
    </transition>

    <!-- 編集 -->
    <transition name="popup">
      <SPBookmarkEdit
        v-if="state.visibleBookmarkEdit"
        @closeBookmarkEdit="state.visibleBookmarkEdit = false; state.isOpenMenu = false"
      />
    </transition>

    <!-- 削除 -->
    <transition name="popup">
      <SPBookmarkDeleteConfirm
        v-if="state.visibleBookmarkDeleteConfirm"
        @closeBookmarkDeleteConfirm="state.visibleBookmarkDeleteConfirm = false"
      />
    </transition>

    <div id="wrapper">

      <div id="menu-btn" class="menu-btn">
        <div role="button" class="menu-btn-2"
          @click="state.visibleMenu = true;state.visibleWindowDetail = false"
        >
          <IconMenu class="icn" />
        </div>
      </div>

      <div id="navi-btn" class="navi-btn"
        v-if="data.tags.length > 0 || data.filterTags.length > 0"
        @click="state.vieibleBookmarkTagExtract = true"
      >
        <FontawesomeIcon :icon="['fas', 'ellipsis-v']" class="icn" />
      </div>


      <!-- div#header:start -->
      <div id="header">
        <header class="header">
          <SPButtonHistoryBack />
          <div class="header-title">
            <h1>ブックマーク</h1>
          </div>
        </header>
      </div>

      <!-- div#header:end -->
      <div id="main">
        <div class="main">
          <div class="main-heading">
            <div class="main-heading-row main-heading-result">
              <div v-if="data.count !== null" class="main-heading-result-num col-8">{{data.count}}件</div>
            </div>
          </div>

          <SPScrollList
            :complete="data.complete"
            @bottomDisplayed="action.load"
            @scroll="handleScroll"
          >
            <p v-if="data.complete && data.count <= 0" class="ml20 mt20 txt">ブックマークはありません。</p>
            <template v-for="(dateLists, date) in data.groupDateLists">
              <div :key="'bookmark_date_' + date" class="date">
                {{formatDate(date)}}
              </div>
              <ul :key="'bookmark_lists_' + date" class="list-result list-result-02">
                <li v-for="(list, dateIndex) in dateLists" :key="'date_'+ date + 'list' + dateIndex"
                 class="list-result-item"
                 :class="{'is-menu-visible': state.isOpenMenu}">
                  <div class="list-result-item-main">

                    <template v-if="list.deleted == 1">
                      <p class="list-result-sup">閲覧できなくなりました。</p>
                      <div class="list-result-title is-inactive"><p>{{list.title}}</p></div>
                    </template>
                    <template v-else-if="list.auth_message">
                      <p class="list-result-sup">{{list.auth_message}}</p>
                      <div class="list-result-title is-inactive"><p>{{list.title}}</p></div>
                    </template>
                    <template v-else>
                      <div class="list-result-title"><a @click="action.routeList(list)" role="button">{{list.title}}</a></div>
                    </template>

                    <div class="list-result-note" v-if="list.type == 'qa'">
                      <div class="list-result-sup">Q&A・事例</div>
                      <div class="list-result-sup">{{list.book_name}}</div>
                    </div>
                    <div class="list-result-note" v-else-if="list.type == 'knowledge'">
                      <div class="list-result-sup"><span class="category-item">最新ナレッジ</span><span class="category-item">{{list.knowledge_type_name}}</span></div>
                      <div class="list-result-sup">{{formatDate(list.content_created)}}</div>
                    </div>
                    <div class="list-result-note" v-else-if="list.type == 'pj'">
                      <div class="list-result-sup">資料</div>
                      <div class="list-result-sup">{{list.book_name}}</div>
                    </div>

                    <div class="list-result-tags">
                      <div v-for="(tag, tagIndex) in list.tags" :key="'tag_' + tagIndex" class="tag">
                        <div class="tag-wrap">
                          <span class="tag-text">{{tag.name}}</span>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="list-result-item-sub">
                    <div class="button edit">
                      <button role="button" class="btn"
                        @click="action.editItem(list.bookmark_id)"
                      >
                        編集
                      </button>
                    </div>
                    <div class="button delete">
                      <button class="btn" type="button"
                        @click="action.deleteItem(list.bookmark_id)"
                      >
                        <FontawesomeIcon :icon="['far', 'times']" class="icn" />
                      </button>
                    </div>
                  </div>
                  <button class="list-result-item-menu"
                    @click="state.isOpenMenu = !state.isOpenMenu"
                  >
                    <FontawesomeIcon :icon="['fas', 'ellipsis-v']" class="icn" />
                  </button>
                </li>
              </ul>
            </template>

          </SPScrollList>
        </div>
      </div>


    </div>
  </div>
  <!-- div#body:end -->
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'

import { BookmarkList } from '@/logic/bookmark/BookmarkList'

import SPMenu from '@/components/sp/popup/SPMenu.vue'
import SPBookmarkTagExtract from '@/components/sp/popup/SPBookmarkTagExtract.vue'
import SPBookmarkDeleteConfirm from '@/components/sp/popup/SPBookmarkDeleteConfirm.vue'
import SPBookmarkEdit from '@/components/sp/popup/SPBookmarkEdit.vue'
import SPScrollList from '@/components/sp/partial/SPScrollList.vue'

export default defineComponent({
  components: {
    SPMenu,
    SPBookmarkTagExtract,
    SPBookmarkEdit,
    SPBookmarkDeleteConfirm,
    SPScrollList
  },
  setup (props, context) {
    return { ...BookmarkList(props, context) }
  }
})
</script>

<style lang="scss" scoped>
.main {
  &-heading-row {
    height: $sp-main-heading-height;
  }
  &-container {
    @include changeHeightOnScroll($sp-header-height + $sp-main-heading-height);
    .date {
      font-size: 1.4rem;
      color: $color-content;
      padding: 32px 20px;
      background-color: $color-bg-paper;
    }
  }
}
.menu-btn {
  &-2 {
    border-top-left-radius: 8px;
    .icn {
      transition: all .2s ease;
    }
    .icn-opened {
      opacity: 0;
    }
    .icn-closed {
      opacity: 1;
    }
  }
}
.list-result {
  &-item {
    .category-item:not(:last-child) {
      margin-right: 1em;
    }
  }
}
// .main-heading-delete{
//   text-align: right;
// }
// .main-heading-delete a{
//   color: #005BAC;
// }
// .list-result-02 .list-result-item-menu .fa-times{
//   font-size: 12px;
//   color: #3E3E3E;
// }
// .list-result-state{
//   font-size: 14px;
//   font-weight: normal;
//   color: #999;
// }
// .list-result-title{
//   color: #ccc;
// }
// .list-result-state + .list-result-title{
//   margin-top: 13px;
// }
// .list-result-text,
// .list-result-category,
// .list-result-author,
// .list-result-date{
//   ul{
//     li{
//       list-style: none;
//       font-size: 14px;
//       color: #999999;
//     }
//   }
// }
// .list-result-text,
// .list-result-category,
// .list-result-date{
//   margin-top: 15px;
//   ul{
//     letter-spacing: -0.4em;
//     li{
//       display: inline-block;
//       letter-spacing: normal;
//       margin-right: 15px;
//     }
//   }
// }
// .list-result-author{
//   margin-top: 1px;
//   min-height: 40px;
//   line-height: 40px;
//   ul{
//     li{
//       img{
//         vertical-align: middle;
//         margin-left: 10px;
//       }
//     }
//   }
// }
// .list-result-author + .list-result-text,
// .list-result-author + .list-result-category{
//   margin-top: 0;
// }
// .list-result-tags{
//   margin-top: -6px;
// }
</style>
